export const FACE_ORDER = Object.freeze(['U', 'R', 'F', 'D', 'L', 'B']);

export const COLOR_ORDER = Object.freeze(['white', 'yellow', 'red', 'orange', 'blue', 'green']);

export const COLORS = Object.freeze({
  white: Object.freeze({ id: 'white', name: '白色', hex: '#f4f1e8', short: 'W' }),
  yellow: Object.freeze({ id: 'yellow', name: '黄色', hex: '#ffd500', short: 'Y' }),
  red: Object.freeze({ id: 'red', name: '红色', hex: '#e32636', short: 'R' }),
  orange: Object.freeze({ id: 'orange', name: '橙色', hex: '#f05a16', short: 'O' }),
  blue: Object.freeze({ id: 'blue', name: '蓝色', hex: '#1565d8', short: 'B' }),
  green: Object.freeze({ id: 'green', name: '绿色', hex: '#00a65a', short: 'G' }),
});

export const EMPTY_STICKER_COLOR = '#697386';
export const CUBE_BODY_COLOR = '#151a23';
export const STICKER_MATERIAL = Object.freeze({
  roughnessFilled: 0.42,
  roughnessEmpty: 0.58,
  metalness: 0,
  emissiveFilled: 0.12,
  emissiveEmpty: 0.04,
});
export const STICKERS_PER_FACE = 9;
export const CENTER_INDEX = 4;

// 3×3 标准配色：白顶、绿前、红右；对面依次为黄、蓝、橙。
export const FACE_CONFIG = Object.freeze({
  U: Object.freeze({
    name: '顶面',
    color: 'white',
    normal: Object.freeze([0, 1, 0]),
    right: Object.freeze([1, 0, 0]),
    down: Object.freeze([0, 0, 1]),
  }),
  R: Object.freeze({
    name: '右面',
    color: 'red',
    normal: Object.freeze([1, 0, 0]),
    right: Object.freeze([0, 0, -1]),
    down: Object.freeze([0, -1, 0]),
  }),
  F: Object.freeze({
    name: '正面',
    color: 'green',
    normal: Object.freeze([0, 0, 1]),
    right: Object.freeze([1, 0, 0]),
    down: Object.freeze([0, -1, 0]),
  }),
  D: Object.freeze({
    name: '底面',
    color: 'yellow',
    normal: Object.freeze([0, -1, 0]),
    right: Object.freeze([1, 0, 0]),
    down: Object.freeze([0, 0, -1]),
  }),
  L: Object.freeze({
    name: '左面',
    color: 'orange',
    normal: Object.freeze([-1, 0, 0]),
    right: Object.freeze([0, 0, 1]),
    down: Object.freeze([0, -1, 0]),
  }),
  B: Object.freeze({
    name: '背面',
    color: 'blue',
    normal: Object.freeze([0, 0, -1]),
    right: Object.freeze([-1, 0, 0]),
    down: Object.freeze([0, -1, 0]),
  }),
});

export function assertFace(face) {
  if (!FACE_ORDER.includes(face)) {
    throw new RangeError(`未知魔方面：${face}`);
  }
}

export function assertStickerIndex(index, order = 3) {
  const maximum = order * order - 1;
  if (![2, 3].includes(order) || !Number.isInteger(index) || index < 0 || index > maximum) {
    throw new RangeError(`贴纸索引必须是 0–${maximum}，收到：${index}`);
  }
}

export function stickerAddress(face, index) {
  assertFace(face);
  assertStickerIndex(index);
  return `${face}${index}`;
}

export function indexToGrid(index) {
  assertStickerIndex(index);
  return Object.freeze({ row: Math.floor(index / 3), col: index % 3 });
}

export function gridToIndex(row, col) {
  if (![row, col].every(Number.isInteger) || row < 0 || row > 2 || col < 0 || col > 2) {
    throw new RangeError(`行列坐标必须在 0–2 内，收到：${row}, ${col}`);
  }
  return row * 3 + col;
}

export function stickerPosition(face, index, radius = 1.53, spacing = 1) {
  assertFace(face);
  const { row, col } = indexToGrid(index);
  const { normal, right, down } = FACE_CONFIG[face];
  const rowOffset = row - 1;
  const colOffset = col - 1;

  return normal.map((axis, dimension) => (
    axis * radius
    + right[dimension] * colOffset * spacing
    + down[dimension] * rowOffset * spacing
  ));
}

export function isLockedSticker(order, face, index) {
  return order === 3 && FACE_ORDER.includes(face) && index === CENTER_INDEX;
}
